<template>
    <div class="py-6">
        <div id="partners" class="pt-3 pb-0 has-text-centered">
            <img class="px-4 " height="180" width="180" alt="APHP logo" src="../assets/logoAPHP_ParisCite.png">
            <img class="px-4 " height="180" width="180" alt="APHP logo" src="../assets/logoAPHP_CCelton.jpg">
            <img class="px-4 " height="180" width="180" alt="Univ Paris logo" src="../assets/logoUni_ParisCite.png">
            <img class="px-4 " width="100" alt="ARS logo" src="../assets/logo-ars.png">
        </div>
        <div class="has-text-centered pb-4 my-5 px-6">
            <div class="px-3 is-size-6" style="line-height: 1.7em;">
                <p class="">
                    L'allongement de l'espérance de vie et l'augmentation du nombre de personnes âgées souffrant de troubles psychiatriques et psychologiques ont été à l'origine de la création du premier <b>Centre Ressource Régional de Psychiatrie du Sujet Âgé (CRRpsa)</b> labellisé par l'ARS.
                </p>
                <br>
                <p>
                    Proposer une offre de soins spécifiques est important compte tenu de la complexité des troubles psychiatriques du sujet âgé, de la plus grande résistance thérapeutique et de la fréquence des comorbidités somatiques qui complexifient la prise en charge.
                </p>
                <router-link class="mt-4 button is-danger is-normal" :to="'/page/missions'">>> Découvrir le CRRPSA</router-link>
            </div>
        </div>
        <div class="my-3 px-3">
            <Carousel />
        </div>

        <div class="columns is-variable mt-6 py-6 px-5 has-text-centered">
            <div data-aos="zoom-in" class="column is-6">
                <div>
                    <h2 class="title is-4">Equipes mobiles</h2>
                    <img width="120" alt="carte" src="../assets/map.svg">
                </div>
                <p class="pt-5">Les équipes mobiles de Psychiatrie du sujet âgé se développent en Ile-de-France depuis quelques années afin de répondre à la difficulté d’accès aux soins, liée au manque de mobilité des personnes, à leur isolement, leur fragilité et au risque de situation de rupture.</p>
                <router-link class="mt-4 button is-danger is-normal" :to="'/equipesmobiles'">Les EMPSA</router-link>
            </div>

            <div  data-aos="zoom-in" class="column is-6 spacemobile">
                <div>
                    <h2 class="title is-4">Recherche / Publications</h2>
                    <img width="100" alt="recherche" src="../assets/recherche.png">
                </div>
                <p class="pt-5">Découvrez les thématiques de recherche du CRRpsa et une liste de publications, nationales et internationales, sur le thème des équipes mobiles.</p>
                <router-link class="mt-4 button is-danger is-normal" :to="'/page/recherche'">Recherche & publications</router-link>
            </div>
        </div>
        <div class="columns is-variable mt-2 py-6 px-6 has-text-centered">
            <div data-aos="zoom-in" class="column is-6">
                <div>
                    <h2 class="title is-4">Journées thématiques</h2>
                    <img width="100" alt="journee" src="../assets/mediator.png">
                </div>
                <p class="pt-5">Au lendemain de sa labellisation, le CRRpsa a instauré le principe d'une journée annuelle d’information, de communication et d’échanges entre professionnels.</p>
                <router-link class="mt-4 button is-danger is-normal" :to="'/page/journees-thematiques'">Nos journées</router-link>
            </div>
            <div data-aos="zoom-in" class="column is-6 spacemobile">
                <div>
                    <h2 class="title is-4">Enseignement</h2>
                    <img width="100" alt="conference" src="../assets/conference.png">
                </div>
                <p class="pt-5">En savoir plus sur le Diplôme Universitaire Psychiatrie du sujet âgé, Faculté Paris Descartes.</p>
                <router-link class="mt-4 button is-danger is-normal" :to="'/page/enseignement'">Enseignement</router-link>
            </div>
        </div>
    </div>
</template>
<script>
import 'aos/dist/aos.css';
import Carousel from './Carousel.vue'
import AOS from 'aos';

AOS.init()
export default {
    name: 'Landing',
    data: function() {
        return {
            maintitle: 'Site du CRRPSA | Bienvenue!'
        }
    },
    components: {
        Carousel,
    }
}
</script>
<style scoped>
.rubrique {
    margin-bottom: 55px;
}

th {
    background-color: #eee;
}

body {
    overflow-x: hidden;
}

@media only screen and (max-width: 600px) {
  #partners img {
    margin: auto auto;
    display: block;
    padding-bottom: 25px;
  }

  .spacemobile{
    margin-top: 100px;
  }

}
</style>